import httpService from '@Utils/httpService';

const baseUrl = 'api/Management/Feedback';

/**
 * Management-only Feedback endpoints (AVA-349).
 * Mirrors MODS.Forge.Api/Controllers/Management/Feedback/FeedbackManagementController.cs.
 *
 * The server gate is [HasManagementPermission], which is the permission AND a
 * management email domain — holding CompaniesManagement inside a tenant is not
 * enough. The UI gate is a convenience, never the security boundary.
 */
export default {
  /** { intervalDays, configuredIntervalDays, requestedAt } */
  getSettings() {
    return httpService.get({ url: `${baseUrl}/settings` });
  },

  /** @param {number} intervalDays 1..3650; rejects FEEDBACK_INTERVAL_OUT_OF_RANGE */
  updateSettings(intervalDays) {
    return httpService.put({ url: `${baseUrl}/settings`, data: { intervalDays } });
  },

  /**
   * Re-prompt every user on their next session, clearing live snoozes.
   * Response: { requestedAt, snoozesCleared }
   */
  triggerRound() {
    return httpService.post({ url: `${baseUrl}/rounds` });
  },

  /**
   * Cross-tenant submissions list.
   * @param {{ page, itemsPerPage, companyId, ratings, createdFrom, createdTo, sortBy, sortDesc }} params
   *        `ratings` is an array — sent as repeated query keys (?ratings=1&ratings=2).
   *        sortBy is one of CreateDate | Rating | CompanyName | UserName.
   * Response: PagedResult { items, total, page, itemsPerPage, totalPages }
   */
  list(params) {
    return httpService.get({ url: baseUrl, params });
  },
};
